import {
	EuiLoadingSpinner,
	EuiFlexGroup,
	EuiFlexGroupProps,
	EuiFlexItem,
} from '@equipmentshare/ds2'

import useInvoiceDetails from 'hooks/useInvoiceDetails'

export type InvoiceDisplayProps = {
	targetId: number,
} & Partial<EuiFlexGroupProps>

export default function InvoiceDisplay( { targetId, ...props }: InvoiceDisplayProps ) {
	const { loading, invoiceNo, orderedBy } = useInvoiceDetails( targetId )

	return (
		<EuiFlexGroup direction="column" style={{ minWidth: '200px' }} gutterSize="s" {...props}>
			{ loading && <EuiLoadingSpinner size="s" /> }
			{ !loading && !invoiceNo && <EuiFlexItem>--</EuiFlexItem> }
			{ invoiceNo && <EuiFlexItem>INV-{invoiceNo}</EuiFlexItem> }
			{ orderedBy && <EuiFlexItem>{orderedBy}</EuiFlexItem> }
		</EuiFlexGroup>
	)
}
